import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { getAllEvents, getContactsByEvent,getEventById, getBookingByEventId } from "api";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import Spinners from "components/Common/Spinner";
import { getUserRole } from "utils/storage";

function ContactList() {
  document.title = "ContactList | EventoX";
  const [eventList, setEventList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [contactList, setContactList] = useState([]);
  const [tmpContactList, setTmpContactList] = useState([]);

  
  
  useEffect(() => {
    fetchAll();
    
    // fetchContacts();
  }, []);
  useEffect(() => {
    const fetchContactsData = async () => {
      const role = getUserRole();
      
      try {
        setIsLoading(true);
        let contacts = [];

        if (selectedEvent) {
          const response = await getBookingByEventId(selectedEvent.value);
          contacts = (response || []).map(booking => {
            const primaryDetails = booking.bookingObject?.primaryContactDetails;
            const fallbackContact = booking.Contact;
            
            return {
              firstName: primaryDetails?.firstName || fallbackContact?.firstName || "",
              lastName: primaryDetails?.lastName || fallbackContact?.lastName || "",
              email: primaryDetails?.email || fallbackContact?.email || "",
              phoneNo: primaryDetails?.phoneNo || fallbackContact?.phoneNo || "",
              address: primaryDetails?.address || "",
              city: primaryDetails?.city || ""
            };
          });
        } else if (role === 1 || role === '1') {
          const response = await getContactsByEvent();
          contacts = (response || []).map(contact => ({
            firstName: contact.firstName || "",
            lastName: contact.lastName || "",
            email: contact.email || "",
            phoneNo: contact.phoneNo || "",
            address: contact.address || "",
            city: contact.city || ""
          }));
        }
        const filteredContacts = contacts.filter((item, index, self) => {
          const normalizedEmail = item.email?.trim().toLowerCase();
          if (!normalizedEmail) return true;
          return (
            index === self.findIndex((t) => t.email?.trim().toLowerCase() === normalizedEmail)
          );
        });

        setContactList(filteredContacts);
      } catch (error) {
        console.error("Error fetching contacts:", error);
        setContactList([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContactsData();
  }, [selectedEvent]);

  const fetchAll = async () => {
    try {
      const respAllEvent = await getAllEvents();
      const eventOptions = respAllEvent.map((item) => ({
        value: item.eventId,
        label: item.eventName,
      }));
      setEventList(eventOptions);
    } catch (error) {
      console.log(error);
    }
  };

//   const fetchContacts = async () => {

//     try {
//       setIsLoading(true);
//       const response = await getContactsByEvent();
//      const filteredContactList = response.filter((item, index, self) => {
//   const normalizedEmail = item.email?.trim().toLowerCase();

//   return (
//     index ===
//     self.findIndex(
//       (t) => t.email?.trim().toLowerCase() === normalizedEmail
//     )
//   );
// });

//       const role = getUserRole();
//       if (role === 1 || role === '1') {
//         setContactList(filteredContactList);
//       } else {
//         setContactList([]);
//       }
//       setTmpContactList(filteredContactList);
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorFn: (row) => `${row.firstName} ${row.lastName}`,
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Phone No",
        accessorKey: "phoneNo",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Address",
        accessorKey: "address",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Location",
        accessorKey: "city",
        enableColumnFilter: false,
        enableSorting: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboards" breadcrumbItem="Contact List" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col xl="5">
                      <div className="col-md-12">
                        <Select
                          value={selectedEvent}
                          placeholder="Select Event"
                          onChange={(data) => setSelectedEvent(data)}
                          options={eventList}
                          className="select2-selection"
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {isLoading ? (
              <Spinners setLoading={setIsLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={contactList}
                      isGlobalFilter={true}
                      SearchPlaceholder="Search..."
                      isCustomPageSize={true}
                      tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default ContactList;